<!-- Created by henian.xu on 2020/4/28. -->

<template>
    <div
        class="edit-study-history"
        @click="onSwitch"
    >
        <div :class="['out-show',{noop:!model || !model.length}]">
            <div
                v-if="model && model.length"
                class="inner">
                <div
                    v-for="(item,index) in model"
                    :key="index"
                    class="item">
                    <div class="header">
                        <div class="education">{{(degreeDictionaryMap[item.education]||{}).name||''}}</div>
                        <div class="time">毕业时间: {{item.graduationDate}}</div>
                    </div>
                    <div class="body">{{item.school}}</div>
                    <div class="footer">毕业证编码: {{item.idCode}}</div>
                </div>
            </div>
            <div
                v-else
                class="ctrl">
                <div class="label">{{placeholder}}</div>
                <XIcon
                    content="f012"
                    theme="g5"
                    size="small" />
            </div>
        </div>

        <!--popup-->
        <transition :name="aniName">
            <Page
                ref="popup"
                class="popup"
                v-show="popupShow"
            >
                <PageNav label="编辑学习经历"></PageNav>
                <Container>
                    <XForm
                        ref="form"
                        :model="formModel"
                        :rules="formRules"
                        border
                        align="right"
                    >
                        <div
                            v-for="(item,index) in formModel"
                            :key="index"
                            class="edit-study-history-block"
                        >
                            <FormItem
                                label="程度:"
                                :prop="`${index}.education`"
                                :rules="formRules.required"
                            >
                                <XSelect
                                    :data="degreeDictionaryList"
                                    v-model="item.education"
                                ></XSelect>
                            </FormItem>
                            <FormItem
                                label="所在院校:"
                                :prop="`${index}.school`"
                                :rules="formRules.required"
                            >
                                <XInput v-model="item.school"/>
                            </FormItem>
                            <FormItem
                                label="毕业时间:"
                                :prop="`${index}.graduationDate`"
                                :rules="formRules.required"
                            >
                                <DatePicker
                                    v-model="item.graduationDate"
                                    format="YYYY年MM月DD日"/>
                            </FormItem>
                            <FormItem
                                label="毕业证编码:"
                                :prop="`${index}.idCode`"
                            >
                                <XInput v-model="item.idCode"/>
                            </FormItem>
                            <div class="ctrl">
                                <XButton
                                    theme="danger"
                                    size="small"
                                    lock-text
                                    @click="()=>{onDel(item,index)}"
                                >
                                    <XIcon
                                        class="ma-rs"
                                        content="f01a"
                                    />删除
                                </XButton>
                            </div>
                        </div>
                    </XForm>
                    <div
                        v-if="!maxCount||(maxCount && formModel.length<maxCount)"
                        class="pa-a">
                        <XButton
                            label="添加经历"
                            theme="primary"
                            size="big"
                            lock-text
                            fill
                            radius="all"
                            @click="onAdd"
                        ></XButton>
                    </div>
                    <div
                        v-else-if="maxCount"
                        class="pa-a ta-c tc-minor">最多添加 {{maxCount}} 条</div>
                </Container>
                <PageBar position="bottom">
                    <XButton
                        class="item"
                        label="取消"
                        theme="second"
                        @click="()=>{onCancel()}"
                    ></XButton>
                    <XButton
                        class="item"
                        label="确认"
                        theme="main"
                        @click="()=>{onConfirm()}"
                    ></XButton>
                </PageBar>
            </Page>
        </transition>
    </div>
</template>

<script>
import { popupMixin } from 'packages/mixins';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
    name: 'EditStudyHistory',
    mixins: [popupMixin],
    data() {
        return {
            formModel: [],
            formRules: {
                required: {
                    required: true,
                    message: '不能为空',
                },
            },
            degreeDictionaryList: [],
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '添加经历',
        },
        degreeDictionary: {
            type: String,
            default: 'education',
        },
        maxCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapGetters('Dictionary', ['educationList', 'educationMap']),
        model: {
            get() {
                /* [
                    {
                        education: '', // 程度(学历)
                        school: '', // 所在院校
                        graduationDate: '', // 毕业时间
                        idCode: '', // 毕业证编码
                    },
                ] */
                return this.value;
            },
            set(val) {
                const value = JSON.parse(JSON.stringify(val)).sort((a, b) => {
                    const av = dayjs((a.graduationDate || '').replace(/[年月日]/g, '-')).valueOf();
                    const bv = dayjs((b.graduationDate || '').replace(/[年月日]/g, '-')).valueOf();
                    return av - bv;
                });
                this.$emit('input', value);
            },
        },
        degreeDictionaryMap() {
            return this.degreeDictionaryList.reduce((pre, cur) => {
                pre[cur.id] = cur;
                return pre;
            }, {});
        },
    },
    watch: {
        popupShow: {
            handler(val, oldVal) {
                if (!val || oldVal) return;
                console.log(val);
                this.formModel = JSON.parse(JSON.stringify(this.model));
            },
            immediate: true,
        },
        degreeDictionary: {
            handler(val) {
                if (!val) return;
                this.getDegreeDictionary();
            },
            immediate: true,
        },
    },
    methods: {
        async getDegreeDictionary() {
            const { degreeDictionary } = this;
            const { data } = await this.$api.Comm.Rs.Dic.dicEntry(degreeDictionary);
            this.degreeDictionaryList = [{ id: '', name: '请选择' }].concat(data);
        },
        onAdd() {
            this.formModel.push({
                education: '', // 程度(学历)
                school: '', // 所在院校
                isSoFar: 1, // 值为:1;0
                graduationDate: '', // 毕业时间
                idCode: '', // 毕业证编码
            });
        },
        onDel(item, index) {
            this.formModel.splice(index, 1);
        },
        onCancel() {
            this.close();
        },
        async onConfirm() {
            await this.$refs.form.validate();
            this.model = this.formModel;
            return this.close();
        },
    },
};
</script>

<style lang="scss">
.edit-study-history {
    flex: 1;
    > .out-show {
        > .inner {
            > .item {
                border: 1px solid mix(#fff, $color-main, 50);
                border-radius: $padding-small;
                padding: $padding-small;
                background-color: mix(#fff, $color-main, 80);
                color: mix(#000, $color-main, 50);

                + .item {
                    margin-top: $margin-small;
                }

                > .header {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    > .education {
                        font-weight: bold;
                    }
                    > .time {
                        font-size: $little * 100%;
                    }
                }
                > .body {
                    margin: $margin-small 0;
                }
                > .footer {
                    font-size: $little * 100%;
                }
            }
        }
        > .ctrl {
            line-height: $formItemHeight;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            > .label {
                flex: 1;
            }
        }

        &.noop {
            color: $gray6;
        }
    }
}

.edit-study-history-block {
    position: relative;
    padding: 0 $padding;
    margin: $padding 0;
    > .ctrl {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        > .x-button {
            border-bottom-left-radius: $padding;
            border-bottom-right-radius: $padding;
        }
    }
}
</style>
